(function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    const epi = window.epi ?? (window.epi = {});
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime
    epi.EPiServer = epi.EPiServer ?? {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms = epi.EPiServer.Forms ?? { Validators: {} };

    const keyPascal = "Securitas.PublicWeb.Web.Models.Elements.DateValidator";
    const keyLower = keyPascal.toLowerCase();

    function getInput(fieldName: string): HTMLInputElement | null {
        try {
            // CSS.escape is in lib.dom.d.ts; the try/catch handles environments where CSS is unavailable
            const esc = CSS.escape(fieldName);
            return document.querySelector(`[name="${esc}"]`);
        } catch {
            return document.querySelector(`[name="${fieldName}"]`);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- EPiServer validator metadata shape is runtime-defined
    function coreValidate(fieldName: string, fieldValue: string, validatorMetaData: any) {
        const input = getInput(fieldName);

        if (!fieldValue || fieldValue.trim() === "") return true;

        const iso = fieldValue.trim();
        const parsed = new Date(iso);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer validator metadata shape is defined at runtime, not statically typed
        const errorMessage = (validatorMetaData?.model?.message) || "Please enter a valid date.";

        if (isNaN(parsed.getTime())) {
            return {
                isValid: false,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer validator metadata shape is defined at runtime, not statically typed
                message: errorMessage
            };
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer validator metadata shape is defined at runtime, not statically typed
        const minStr: string | null = (validatorMetaData && validatorMetaData.min) || (input && input.getAttribute("min"));
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer validator metadata shape is defined at runtime, not statically typed
        const maxStr: string | null = (validatorMetaData && validatorMetaData.max) || (input && input.getAttribute("max"));

        if (minStr) {
            const minDate = new Date(minStr);
            if (!isNaN(minDate.getTime()) && parsed.getTime() < minDate.getTime()) {
                return {
                    isValid: false,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer validator metadata shape is defined at runtime, not statically typed
                    message: errorMessage
                };
            }
        }

        if (maxStr) {
            const minDate = new Date(maxStr);
            if (!isNaN(minDate.getTime()) && parsed.getTime() > minDate.getTime()) {
                return {
                    isValid: false,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer validator metadata shape is defined at runtime, not statically typed
                    message: errorMessage
                };
            }
        }

        return true;
    }

    const validatorObject = { validate: coreValidate };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyLower] = validatorObject;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyPascal] = validatorObject;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyLower + ":fn"] = coreValidate;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyPascal + ":fn"] = coreValidate;
})();